<script>
  import pessoaServico from '~modulos/pessoa/servico';
  import DadosCadastrais from './compartilhado/FormDadosCadastrais.vue';
  import DadosPagamento from './compartilhado/FormDadosPagamento.vue';
  import solicitacaoPagamentoServico from '../../servico';
  import AdicionarArquivos from '~componentes/FormAdicionarArquivos.vue';
  import ListaDeArquivos from '~componentes/ListaDeArquivos.vue';

  export default {
    components: { DadosCadastrais, DadosPagamento, AdicionarArquivos, ListaDeArquivos },
    data() {
      return {
        documento: '',
        mostrarFormulario: false,
        solicitacao: this.camposSolicitacao(),
        carregando: false,
        configuracao: this.$storage.configuracao(),
        arquivos: [],
        desabilitarBeneficiario: false,
      }
    },
    mounted() {
      this.$root.tituloDaPagina = `Solicitação de Pagamento de Estrangeiro PJ - ${this.$route.params.id ? 'Editar #' + this.$route.params.id : 'Nova'}`;
      this.$root.botaoAcaoTexto = 'Nova';
      this.$root.botaoAcaoIcon = 'fa-plus';
      this.$root.botaoAcaoLink = 'solicitacao-pagamento-estrangeiro-pj.nova';
    },
    methods: {
      buscaDesabilitarBeneficiario() {
        if (this.configuracao.permissaoAlteracaoNomeBeneficiario != 0)
          return false;

        if (!this.solicitacao.documentoTerceiro)
          return false;

        return pessoaServico
          .buscaestrangeiro(this.solicitacao.documentoTerceiro)
          .then(pessoa => {
            if (pessoa.nomePessoaFisicaJuridica)
              this.desabilitarBeneficiario = true;
          })
          .catch(error => {
          });
      },
      buscarBeneficiario() {
        $('#avancar').button('loading');

        return pessoaServico
          .buscaestrangeiro(this.documento)
          .then(pessoa => {
            $('#avancar').button('reset');

            this.buscaDesabilitarBeneficiario();
            this.solicitacao.nomeTerceiro = pessoa.nomePessoaFisicaJuridica.substring(0, 100);
            this.solicitacao.endereco = pessoa.endereco.substring(0, 60);
            this.solicitacao.numero = pessoa.numero.substring(0, 10);
            this.solicitacao.complemento = pessoa.complemento.substring(0, 80);
            this.solicitacao.bairro = pessoa.bairro.substring(0, 60);
            this.solicitacao.cidade = pessoa.cidade.substring(0, 60);
            this.solicitacao.uf = pessoa.estado.substring(0, 2);
            this.solicitacao.cep = pessoa.cep;
            this.solicitacao.pisPasep = pessoa.pisPasep;
            this.solicitacao.telefoneResidencial = pessoa.telefone1;
            this.solicitacao.telefoneComercial = pessoa.telefone2;
            this.solicitacao.fax = pessoa.fax;
            this.solicitacao.emailTerceiro = pessoa.email.substring(0, 300);
            this.solicitacao.pais = pessoa.pais.substring(0, 30);
            this.solicitacao.documentoTerceiro = this.documento;
            this.$set(this, 'mostrarFormulario', true);
            this.mostrarInstrucoes();
            this.$events.emit('carregarProjetos');
          })
          .catch(error => {
            $('#avancar').button('reset');

            this.solicitacao.documentoTerceiro = this.documento;

            this.$set(this, 'mostrarFormulario', true);
            this.mostrarInstrucoes();
            this.$events.emit('carregarProjetos');
          });
      },
      validarBeneficiario() {
        this.$validator
          .validate('documento', this.documento)
          .then(valido => {
            if (!valido) throw new Error("validacao");
          })
          .then(this.buscarBeneficiario)
          .catch(erro => {
            this.$mensagemErro(erro);
          });
      },
      mostrarInstrucoes() {
        if (!this.configuracao.instrucoesSolPagamentoEstrangeiroPJ || this.$route.params.id) return;

        this.$swal({
          title: 'Instruções da solicitação',
          html: this.configuracao.instrucoesSolPagamentoEstrangeiroPJ.replace(/\r\n/g, '<br>'),
          type: 'info',
          confirmButtonText: 'Ok, entendi!',
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      },
      salvar() {
        $('#salvar').button('loading');

        this.$refs.dadosCadastrais
          .validar()
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados-cadastrais"]').tab('show');
            }

            return valido;
          })
          .then(this.$refs.dadosPagamento.validar)
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados-pagamento"]').tab('show');
            }

            return valido;
          })
          .then(this.enviar)
          .then(id => {
            this.$imprimirRelatorio('solicitacao-pagamento-estrangeiro-pj.relatorio', id, 'solicitacao-pagamento-estrangeiro-pj');
          })
          .catch(erro => {
            $('#salvar').button('reset');
            this.$mensagemErro(erro, 'Erro ao salvar a solicitação.');
          });
      },
      enviar(valido) {
        if (!valido) throw new Error("validacao com erro");

        const copiaSolicitacao = JSON.parse(JSON.stringify(this.solicitacao));

        copiaSolicitacao.arquivosDeletados = this.$refs.listaArquivos.deletados;

        if (this.$route.params.id) {
          return solicitacaoPagamentoServico.alterar(copiaSolicitacao, this.$refs.adicionarArquivos.arquivos, this.$route.params.idCript);
        } else {
          return solicitacaoPagamentoServico.adicionar(copiaSolicitacao, this.$refs.adicionarArquivos.arquivos);
        }
      },
      camposSolicitacao() {
        return {
          idCoordenador: null,
          dataSolicitacao: null,
          dataPagamento: '',
          documentoTerceiro: null,
          nomeTerceiro: null,
          observacao: '',
          solicitacaoEfetivada: null,
          formaPagamento: '',
          agencia: null,
          banco: null,
          contaCorrente: null,
          valor: '',
          pertenceQuadro: false,
          tipoQuadro: '',
          matricula: null,
          outroQuadro: null,
          dataNascimento: '',
          identidade: null,
          inss: null,
          pisPasep: null,
          cmc: null,
          numCmc: null,
          endereco: null,
          numero: null,
          complemento: null,
          bairro: null,
          cidade: null,
          cep: null,
          uf: '',
          telefoneResidencial: null,
          telefoneComercial: null,
          fax: null,
          tipoPagamento: '',
          statusSolicitacao: null,
          dataLiberacao: null,
          observacaoLiberacao: null,
          liberacaoCoordenador: null,
          dadosVerificados: null,
          totalReenvio: null,
          siafi: null,
          tipoConta: '',
          idUsuario: null,
          pagamentoDiaria: null,
          liberacaoCoordenador2: null,
          idRubrica: '',
          idSubrubrica: '',
          idConta: '',
          idProtocolo: null,
          tipoSolicitacao: 4,
          emailTerceiro: null,
          idSetorSolicitacao: null,
          idResponsavelSolicitacao: null,
          idUsuarioResponsavel: null,
          justicicativa: null,
          descricao: null,
          idDetalheRateio: null,
          idCategoriaFinanceira: null,
          inssOutraFonte: false,
          inssOutraFonteValor: '',
          idContaPagar: null,
          notaFiscal: null,
          dataEmissao: '',
          dataVencimento: '',
          idContrato: null,
          inscricaoMunicipal: null,
          nomeSolicitante: null,
          emailSolicitante: null,
          telefoneSolicitante: null,
          pais: null,
          idMoeda: '',
          rateio: {
            idProjeto: '',
            valorRateio: '',
            idDetalheRateio: '',
            idProjetoMetaEtapa: '',
            projeto: {
              idProjeto: '',
              nomeProjeto: '',
              utilizarMetaEtapaProjeto: false,
            }
          }
        };
      },
      carregar(id) {
        this.carregando = true;

        let solicitacao = null;
        let idProjeto = null;

        solicitacaoPagamentoServico
          .obterPorId(id)
          .then(dados => {
            solicitacao = dados;
            idProjeto = solicitacao.rateio.idProjeto;
          })
          .then(() => this.$refs.dadosCadastrais.listaContas(idProjeto))
          .then(() => {
            if (solicitacao.rateio.projeto.utilizarMetaEtapaProjeto) {
              this.$refs.dadosCadastrais.listaDeMetaEtapas(idProjeto)
            }
          })
          .then(() => {
            if (this.configuracao.exibirRubricaSubrubricaSolicitacaoWeb) {
              return this.$refs.dadosCadastrais.listaDeRubricas(idProjeto);
            }
          })
          .then(() => {
            if (this.configuracao.exibirRubricaSubrubricaSolicitacaoWeb) {
              return this.$refs.dadosCadastrais.listaDeSubrubricas(idProjeto, solicitacao.idRubrica);
            }
          })
          .then(() => {
            solicitacao.dataEmissao = this.$options.filters.formatarNumeroEmData(solicitacao.dataEmissao);
            solicitacao.dataVencimento = this.$options.filters.formatarNumeroEmData(solicitacao.dataVencimento);
            solicitacao.dataPagamento = this.$options.filters.formatarNumeroEmData(solicitacao.dataPagamento);
          })
          .then(() => solicitacaoPagamentoServico.arquivos(id))
          .then(arquivos => {
            this.arquivos = arquivos;
          })
          .then(() => {
            this.$set(this, 'solicitacao', solicitacao);
            this.buscaDesabilitarBeneficiario();
            this.carregando = false;
          });
      },
      download(arquivo) {
        solicitacaoPagamentoServico
          .download(this.$route.params.id, arquivo)
          .then(arquivo => {
            arquivo.download();
          });
      },
      resetarComponente() {
        Object.assign(this.$data, this.$options.data.apply(this));
      },
    },
    created() {
      if (this.$route.params.id) {
        this.$set(this, 'mostrarFormulario', true);
        this.carregar(this.$route.params.id);
      }
    },
    watch: {
    }
  }
</script>

<template>
  <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao">
    <form @submit.prevent="validarBeneficiario">

      <div class="row" v-if="mostrarFormulario">
        <div class="col-xs-12">
          <div class="ibox float-e-margins" v-if="carregando">
            <div class="ibox-content">
              <p class="text-center">
                <i class='fa fa-spinner fa-pulse'></i> Carregando...
              </p>
            </div>
          </div>

          <div class="tabs-container" v-show="!carregando" id="tabs">

            <ul class="nav nav-tabs">
              <li class="active">
                <a data-toggle="tab"
                   href="#tab-dados-cadastrais">
                  Dados cadastrais
                </a>
              </li>
              <li>
                <a data-toggle="tab"
                   href="#tab-dados-pagamento">
                  Dados para o pagamento
                </a>
              </li>
              <li v-if="configuracao.usarArquivosSolicitacaoPagamentos">
                <a data-toggle="tab"
                   href="#tab-adicionar-arquivos">
                  Adicionar arquivos
                </a>
              </li>
              <li v-if="$route.params.id && configuracao.usarArquivosSolicitacaoPagamentos">
                <a data-toggle="tab"
                   href="#tab-lista-arquivos">
                  Arquivos
                </a>
              </li>
            </ul>
            <div class="tab-content">

              <div id="tab-dados-cadastrais" class="tab-pane active">
                <div class="panel-body">
                  <dados-cadastrais ref="dadosCadastrais"
                                    :solicitacao="solicitacao"
                                    :desabilitarBeneficiario="this.desabilitarBeneficiario"
                                    :edicao="!!$route.params.id">
                  </dados-cadastrais>
                </div>
              </div>

              <div id="tab-dados-pagamento" class="tab-pane">
                <div class="panel-body">
                  <dados-pagamento ref="dadosPagamento"
                                   :solicitacao="solicitacao"
                                   :edicao="!!$route.params.id">
                  </dados-pagamento>
                </div>
              </div>

              <div id="tab-adicionar-arquivos" class="tab-pane">
                <div class="panel-body">
                  <adicionar-arquivos ref="adicionarArquivos">
                  </adicionar-arquivos>
                </div>
              </div>

              <div id="tab-lista-arquivos" class="tab-pane">
                <div class="panel-body">
                  <lista-de-arquivos :arquivos="arquivos"
                                     @download="download"
                                     ref="listaArquivos">
                  </lista-de-arquivos>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>

      <div class="row" v-if="!mostrarFormulario">
        <div class="col-sm-12">
          <div class="form-group required" :class="{'has-error': errors.has('documento')}">
            <label class="control-label" for="documento">Email da Empresa Beneficiária</label>

            <input type="text"
                   class="form-control"
                   id="documento"
                   v-model="documento"
                   data-vv-as="e-mail"
                   data-vv-name="documento"
                   maxlength="100"
                   v-caracteres-email
                   v-validate="'required|email'">

            <p class="text-danger" v-show="errors.has('documento')">{{ errors.first('documento') }}</p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <router-link class="btn btn-default"
                         :to="{ name: 'solicitacao-pagamento-estrangeiro-pj' }"
                         v-show="!mostrarFormulario || !!$route.params.id"
                         active-class="">
              <i class="fa fa-arrow-left"></i>
              Voltar
            </router-link>

            <button id="avancar"
                    type="button"
                    class="btn btn-primary"
                    @click="validarBeneficiario"
                    v-show="!mostrarFormulario"
                    data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Carregando...">
              Avançar
              <i class="fa fa-arrow-right"></i>
            </button>

            <button type="button"
                    class="btn btn-default"
                    @click="mostrarFormulario = false, resetarComponente()"
                    v-show="mostrarFormulario && !(!!$route.params.id)">
              <i class="fa fa-arrow-left"></i>
              Volta
            </button>

            <button id="salvar"
                    type="button"
                    class="btn btn-primary"
                    @click="salvar"
                    v-show="mostrarFormulario"
                    data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Salvando...">
              <i class="fa fa-save"></i>
              Salvar
            </button>
          </div>
        </div>
      </div>

    </form>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-pagamento/estrangeiro-pj/componentes/SolicitacaoPagamentoEstrangeiroPjForm.vue